module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_BSOMES.9ae65272.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_BSOMES.png
// module id = 46
// module chunks = 0